import type { Locale } from '../../app/i18n';

const INTL_LOCALE: Record<Locale, string> = { en: 'en-US', ka: 'ka-GE' };

/** Format a post's publish date, e.g. "July 1, 2026". Falls back to the raw string. */
export function formatPostDate(iso: string | null, locale: Locale): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString(INTL_LOCALE[locale], { day: 'numeric', month: 'long', year: 'numeric' });
}
